/*  MUI  */
import { Alert, Box, Button, Typography } from '@mui/material';

/*  Shared  */
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { Notify } from 'application/Shared/Helpers';

/*  React  */
import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withTranslation } from 'react-i18next';

/*  State  */
const state = () => ({
    loaded: false
});

class Token extends Component {
    constructor(props) {
        super(props);
        this.state = state();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = () => {
        this.setState({ loaded: true });
    };

    unload = () => {
        this.setState(state());
    };

    renderCopy = () => {
        const { t } = this.props;

        return (
            <Button
                data-trackid="codeBlock_copyToken"
                color="primary"
                variant="outlinedTransparent"
                size="small"
                style={{
                    marginRight: '4px',
                    whiteSpace: 'nowrap'
                }}
            >
                {t('Common.click_to_copy')}
            </Button>
        );
    };

    renderAlert = () => {
        const { token } = this.props;

        return (
            <Alert
                action={this.renderCopy()}
                icon={false}
                severity="success"
                sx={{
                    backgroundColor: 'scripts.backgroundColor',
                    borderColor: 'scripts.borderColor',
                    cursor: 'pointer'
                }}
            >
                <Typography variant="codeBlock" data-testid="codeBlockToken">
                    {token}
                </Typography>
            </Alert>
        );
    };

    renderToken = () => {
        const { t, token } = this.props;

        return (
            <CopyToClipboard
                text={token}
                onCopy={() => {
                    Notify.s(t('Common.copied'));
                }}
                style={{ padding: '8px' }}
            >
                {this.renderAlert()}
            </CopyToClipboard>
        );
    };

    render() {
        const { t, partner, tokenOnly } = this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        let { label } = this.props;
        let tooltip = '';

        if (!label && !tokenOnly) {
            label = t('Deployment.token');
            tooltip = t('Tooltips.Deployment.token');
            if (partner) {
                label = t('Common.partner_token');
                tooltip = t('Tooltips.Common.partner_token');
            }
        }

        return (
            <Box data-testid="codeBlockTokenContainer">
                {!tokenOnly && (
                    <Box mb="8px" display="inline-flex" alignItems="center">
                        <Typography color="textSecondary" fontWeight={600}>
                            {label}
                        </Typography>
                        {tooltip && <TooltipQ text={tooltip} />}
                    </Box>
                )}
                {this.renderToken()}
            </Box>
        );
    }
}
export default withTranslation()(Token);
